import styled from 'styled-components';

export const StyledLoadingContent = styled.div`
  padding: 7px 9px;
  height: 41px;
  border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
`;

export const StyledLoadingFooter = styled.div`
  padding: 7px 9px;
`;
